import * as React from "react";
import { ReactElement, useContext, useEffect, useState} from 'react';
import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Icon as ChakraIcon,
  Button,
  useColorModeValue,
  Container,
  useToast,
  Flex,
  SimpleGrid,
  StackDivider,
  SpaceProps,
  HStack,
  Tag,
  Link,
  Center,
  Grid,
  GridItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  List,
  ListItem,
  ListIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  IconButton,
  Skeleton
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost, baseUrl } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import headerBg from "../assets/images/header-background.jpg";
import footerBg from "../assets/images/footer-background.jpg";
import cloudsBg from "../assets/images/cloud-background.png";
import parser from "html-react-parser";
import { MotionBox } from "../components/motion";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { Icon, LatLng, LatLngExpression } from 'leaflet';
import markerIconPng from "../assets/images/marker-icon.png";
import { CrowdRiffGallery } from 'react-crowdriff-gallery';
import { MdCheckCircle } from "react-icons/md";
import { AuthContext } from "../context/AuthContext";
import MediaBlock from "../components/media-block";
import FavoritesBlock from "../components/favorites-block";
import ImageBlock from "../components/image-block";
import CrowdBlock from "../components/crowd-block";
import MapBlock from "components/map-block";
import CTABlock from "components/cta-block";
import ImagesBlock from "components/images-block";
import ImagesGridBlock from "components/images-grid-block";
import TabsBlock from "components/tabs-block";
import SlidesBlock from "components/slides-block";
import HighlightsBlock from "components/highlights-block";
import EmbedBlock from "components/embed-block";
import BookBlock from "components/book-block";
import ContentBlock from "components/content-block";
import ShareModal from "components/share-modal";
import { FaHeart } from "react-icons/fa";
import { MdAdd, MdRemove, MdChevronLeft, MdChevronRight } from "react-icons/md";

interface Destination {
  id: string;
  name: string;
  slug: string;
  favorited?: boolean;
  location_latitude: number;
  location_longitude: number;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  [key: string]: any; // For other dynamic properties
}

interface Variables {
  default_destination_img?: string;
  [key: string]: any;
}

const markdownTheme = {
  p: props => {
    const { children } = props;
    return (
      <Text mb={2} fontSize={'0.8em'}>
        {children}
      </Text>
    );
  },
};

const Destination = ({ match }) => {
  const toast = useToast();

  const [destination, setDestination] = useState<Destination>({} as Destination);
  const [loading, setLoading] = useState(true);
  const [variables, setVariables] = useState<Variables>({});

  const [position, setPosition] = useState([40.9133945, -77.7782867]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const authContext = useContext(AuthContext);

  const { isOpen, onOpen, onClose } = useDisclosure()

  const getDestination = () => {
    let data = {} as Destination;
    axios.get(`${apiHost}/destinations/get/${match.params.id}`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          let favorites = JSON.parse(localStorage.getItem("favorites")) || [];
          if (favorites.length > 0) {
            data.favorited = favorites.find((f: any) => f.id == data.id && f.type == "destination");
          }
          setDestination(data);

          let geomarkers = [];
          geomarkers.push({ data: data, location: new LatLng(data.location_latitude, data.location_longitude) })
          setMarkers(geomarkers);

          setPosition([data.location_latitude, data.location_longitude]);

          setLoading(false);
        }
        return res;
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });

    return data;
  };

  const initialMarkers = [];
  const [markers, setMarkers] = useState(initialMarkers);

  const LocationMarkers = () => {
    return (
      <React.Fragment>
        {markers.map(marker => <Marker
          position={marker.location}
          icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })}
          eventHandlers={{
            click: (e) => {
              //setSelectedDestination(marker.data);
              //onOpen();
            },
          }}>
          <Popup>
            {destination.name}<br />
            {marker.data.address}<br />
            {marker.data.city}, {marker.data.state} {marker.data.zip}<br />
            <Link href={`tel:+1${destination.phone}`}>{destination.phone}</Link>
          </Popup>
        </Marker>)}
      </React.Fragment>
    );
  }

  const ChangeView = ({ center, zoom }) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  }

  const getVariables = () => {
    let data = [];
    axios.get(`${apiHost}/variables/get/global`)
      .then(res => {
        data = res.data;
        if (res.status == 200) {
          console.log(data);
          setVariables(data);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const showToast = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 5000,
      isClosable: true
    });
  };

  const addFavorite = (destination) => {
    let favorites = JSON.parse(localStorage.getItem("favorites")) || [];
    destination['type'] = "destination";
    if (!destination.favorited) {
      favorites.push(destination);
      localStorage.setItem("favorites", JSON.stringify(favorites));
    }
    window.location.href = "/favorites";
  }

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    if (destination.d_gallery_images && currentImageIndex < destination.d_gallery_images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const previousImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleKeyDown = (event) => {
    if (lightboxOpen) {
      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowRight') {
        nextImage();
      } else if (event.key === 'ArrowLeft') {
        previousImage();
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDestination();
    getVariables();
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [lightboxOpen, currentImageIndex]);

  return (
    <PageSlideFade>
      <Helmet>
        <title>{destination.name}</title>
        <meta name="description" content={destination.meta_description} />
        <script>
            {destination.scripts}
        </script>
      </Helmet>
      {loading && (
        <Container maxW={'5xl'} pt={10} pb={10}>
          <Box>
            <Skeleton height="750px" />
          </Box>
        </Container>
      )}
      {!loading && !destination.slug && (
        <Box>
          <Container maxW={'5xl'}>
            <Heading
              as={'h3'}
              fontFamily="american"
              fontWeight={600}
              fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
              lineHeight={'100%'}
              textAlign="left"
              mt={{ base: 10, md: 5 }}>
              404 Page Not Found
            </Heading>
            <Box textAlign="left">
              <Button as={Link} href="/">Go to Home Page</Button>
            </Box>
          </Container>
        </Box>
      )}
      {!loading && destination.slug && (
        <>
          {destination.header_img != null ? (
            <Box className="home-header-container" backgroundImage={`url(${destination.header_img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="60dvh">
              <Container maxW={'5xl'}>

              </Container>
            </Box>
          ) : null}
          <Box bg="#143b49">
            <Container maxW={'5xl'}>
              <Grid templateColumns='repeat(6, 1fr)'>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <Text
                    as="h1"
                    textAlign="left"
                    fontFamily="american"
                    fontWeight={600}
                    fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
                    lineHeight={'120%'}
                    color="#fbeec8"
                    mt={{ base: 4, md: 0 }}
                  >{destination.name}</Text>
                </GridItem>
              </Grid>
            </Container>
          </Box>
                    <Box bg="rgb(251, 238, 200)">
            <Container maxW={'5xl'}>
            <Stack direction={{ base: 'column', md: 'row' }}>
              <Box w={{ base: '100%', md: '50%', lg: '65%' }} >
                <Box position="relative">
                  {destination.main_img ? (
                    <Image
                      src={`${destination.main_img}`}
                      w={'100%'}
                      roundedBottomLeft={20}
                      alt={'main image'}
                    />
                  ) : null}
                  {!destination.main_img && variables.default_destination_img ? (
                    <Image
                      src={`${variables.default_destination_img}`}
                      w={'100%'}
                      roundedBottomLeft={20}
                      alt={'main image'}
                    />
                  ) : null}
                  {destination.bd_lowest_rate && (
                    <Link
                      href={destination.reservations_link}
                      target="_blank"
                      fontWeight={'bold'}
                      fontSize="15px"
                      color="white"
                      whiteSpace={'nowrap'}
                      bg="#D51F0C"
                      borderTopStartRadius={"0.375rem"}
                      borderBottomStartRadius={"0.375rem"}
                      borderTopEndRadius={"0.375rem"}
                      borderBottomEndRadius={"0.375rem"}
                      p={2}
                      position="absolute"
                      bottom="10px"
                      right="10px"
                    ><small><em>starting at</em></small><br />${destination.bd_lowest_rate}</Link>
                  )}
                </Box>
              </Box>
              <Box w={{ base: '100%', md: '50%', lg: '35%' }} textAlign="left" bg="white" pl={10} pr={10} pb={5} roundedBottomRight={20}>
                <Heading
                  as={'h3'}
                  fontFamily="american"
                  fontWeight={600}
                  fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
                  lineHeight={'100%'}
                  mt={{ base: 10, md: 5 }}
                  className="mobile-center">
                  <ChakraIcon as={FaHeart} color={destination.favorited ? "red" : "black"} mr={2} cursor="pointer" float="right" marginRight="-10px" onClick={() => { addFavorite(destination); }} />
                  {destination.name}  
                </Heading>

                <Stack className="mobile-center">
                  <Text color="gray.500">{destination.address}<br />
                    {destination.city}, {destination.state} {destination.zip}</Text>
                  <Link href={`tel:+1${destination.phone}`} fontSize="16px;">{destination.phone}</Link>
                </Stack>

                <Box>
                  {destination.sidebar_callout_content ? (
                    <Box
                      color="#222"
                      fontWeight={600}>
                      {parser(destination.sidebar_callout_content)}
                    </Box>
                  ) : null}
                </Box>

                <Stack mt={5}>
                  {destination.website ? (
                    <Button as={Link} href={`${destination.website}`} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Website</Button>
                  ) : null}
                  {destination.phone ? (
                    <Button as={Link} href={`tel:+1${destination.phone}`}  fontSize="0.7em" bg="#D51F0C" color="white">Call</Button>
                  ) : null}
                  {destination.address ? (
                    <Button as={Link} href={`https://www.google.com/maps/dir/?api=1&destination=${destination.address} ${destination.city} ${destination.state} ${destination.zip}`} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Get Directions</Button>
                  ) : null}
                  {destination.map_link ? (
                    <Button as={Link} href={destination.map_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Map</Button>
                  ) : null}
                  {destination.reservations_link ? (
                    <Button as={Link} href={destination.reservations_link} target="_blank" fontSize="0.7em" color="white" bg="#D51F0C">Reservations</Button>
                  ) : null}
                  {destination.restaurant_link ? (
                    <Button as={Link} href={destination.restaurant_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Menu</Button>
                  ) : null}
                  {destination.golf_link ? (
                    <Button as={Link} href={destination.golf_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Golf</Button>
                  ) : null}
                  {destination.facebook_link ? (
                    <Button as={Link} href={destination.facebook_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Facebook</Button>
                  ) : null}
                  {destination.instagram_link ? (
                    <Button as={Link} href={destination.instagram_link} target="_blank"  fontSize="0.7em" bg="#D51F0C" color="white">Instagram</Button>
                  ) : null}
                  {destination.twitter_link ? (
                    <Button as={Link} href={destination.twitter_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">X (Twitter)</Button>
                  ) : null}
                  {destination.youtube_link ? (
                    <Button as={Link} href={destination.youtube_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">YouTube</Button>
                  ) : null}
                  {destination.pinterest_link ? (
                    <Button as={Link} href={destination.pinterest_link} target="_blank" fontSize="0.7em" bg="#D51F0C" color="white">Pinterest</Button>
                  ) : null}
                  <Button onClick={()=> { localStorage.setItem("selectedTipDestination", destination.id); window.location.href='/profile'; }} fontSize="0.7em" bg="#E6DFD3" color="black">Add a Tip</Button>
                  <Button onClick={()=> { localStorage.setItem("selectedDestination", destination.id); window.location.href='/profile'; }} fontSize="0.7em" bg="#E6DFD3" color="black">Add to Itinerary</Button>
                  <ShareModal page={destination} path="d/" />
                </Stack>
              </Box>
            </Stack>
          </Container>
          <Tabs variant="enclosed" w="100%" mt={5} pt={5} bg="white">
            <Container maxW={'5xl'}>
                <Box textAlign="left" ml={5} mt={5} mb={5}>
                  <Text textAlign="left"
                    fontFamily="american"
                    fontWeight={600}
                    lineHeight={'1em'}
                    fontSize={{ base: '2xl', sm: '3xl', md: '3xl' }}>
                    About {destination.name}
                  </Text>
                </Box>

              <Accordion allowToggle={true} w="100%" pb={10} defaultIndex={[0]}>
                    {destination.callout_content || destination.content ? (
                    <AccordionItem key="why">
                            {({ isExpanded }) => (
                              <>
                                <AccordionButton 
                                    bg="#d5200d"
                                    _expanded={{ bg: "#153b4a" }}
                                    _hover={{ bg: "#153b4a" }}
                                    p={4}
                                    fontSize="lg"
                                    fontWeight="bold"
                                    color="white"
                                    borderRadius={0}
                                    border={0}
                                    _focus={{
                                        boxShadow: 'none'
                                    }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Box as="span" flex="1" textAlign="left">
                                      Why Us
                                    </Box>
                                    {isExpanded ? <MdRemove /> : <MdAdd />}
                                </AccordionButton>
                                <AccordionPanel pb={4} pt={2}>
                                    {destination.callout_content ? (
                                      <Box backgroundColor="white"
                                        color="#222"
                                        fontFamily="american"
                                        fontWeight={600}
                                        fontSize={{ base: '2xl', sm: '3xl', md: '4xl' }}
                                        borderRadius={5}>
                                        {parser(destination.callout_content)}
                                      </Box>
                                    ) : null}

                                    {destination.content ? (
                                      <Box className="content-block">
                                        {parser(destination.content)}
                                      </Box>
                                    ) : null}
                                </AccordionPanel>
                              </>
                            )}
                    </AccordionItem>
                     ) : null}
                     {destination.d_amenities && destination.d_amenities.length > 0 ? (
                    <AccordionItem key="amenities">
                            {({ isExpanded }) => (
                              <>
                                <AccordionButton 
                                    bg="#d5200d"
                                    _expanded={{ bg: "#153b4a" }}
                                    _hover={{ bg: "#153b4a" }}
                                    p={4}
                                    fontSize="lg"
                                    fontWeight="bold"
                                    color="white"
                                    borderRadius={0}
                                    border={0}
                                    _focus={{
                                        boxShadow: 'none'
                                    }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Box as="span" flex="1" textAlign="left">
                                      Amenities
                                    </Box>
                                    {isExpanded ? <MdRemove /> : <MdAdd />}
                                </AccordionButton>
                                <AccordionPanel pb={0} pt={8} pl={10}>
                                      <List spacing={3} textAlign="left">
                                        {destination.d_amenities?.map((amenity, index) => (
                                          <ListItem fontSize="16px">
                                            <ListIcon as={MdCheckCircle} color='green.500' />
                                            {amenity.name}
                                          </ListItem>
                                        ))}
                                      </List>
                                </AccordionPanel>
                              </>
                            )}
                    </AccordionItem>
                    ) : null}
                    {destination.d_gallery_images && destination.d_gallery_images.length > 0 ? (
                    <AccordionItem key="gallery">
                            {({ isExpanded }) => (
                              <>
                                <AccordionButton 
                                    bg="#d5200d"
                                    _expanded={{ bg: "#153b4a" }}
                                    _hover={{ bg: "#153b4a" }}
                                    p={4}
                                    fontSize="lg"
                                    fontWeight="bold"
                                    color="white"
                                    borderRadius={0}
                                    border={0}
                                    _focus={{
                                        boxShadow: 'none'
                                    }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Box as="span" flex="1" textAlign="left">
                                      Gallery
                                    </Box>
                                    {isExpanded ? <MdRemove /> : <MdAdd />}
                                </AccordionButton>
                                <AccordionPanel pb={4} pt={2}>
                                  <SimpleGrid columns={{ base: 2, md: 3 }} spacing={5}>
                                    {destination.d_gallery_images?.map((img_url, index) => (
                                      <Box 
                                        key={index}
                                        backgroundImage={`url(${img_url})`} 
                                        backgroundPosition="center center" 
                                        backgroundSize="cover" 
                                        minHeight={{ base: "200px", md: "250px" }}
                                        cursor="pointer"
                                        onClick={() => openLightbox(index)}
                                        _hover={{ opacity: 0.8 }}
                                        transition="opacity 0.2s"
                                      />
                                    ))}
                                  </SimpleGrid>
                                </AccordionPanel>
                              </>
                            )}
                    </AccordionItem>
                    ) : null}
              </Accordion>
            </Container>
          </Tabs>

          {destination.content_blocks?.map((block, index) => (
            <Box key={`block-${index}`}>
              {
                {
                  'anomaly.extension.favorites_block_block': <FavoritesBlock page={destination} block={block} />,
                  'anomaly.extension.media_block_block': <MediaBlock page={destination} block={block} />,
                  'anomaly.extension.image_block_block': <ImageBlock page={destination} block={block} />,
                  'anomaly.extension.crowd_block_block': <CrowdBlock page={destination} block={block} />,
                  'anomaly.extension.map_block_block': <MapBlock page={destination} block={block} />,
                  'anomaly.extension.cta_block_block': <CTABlock page={destination} block={block} />,
                  'anomaly.extension.images_block_block': <ImagesBlock page={destination} block={block} />,
                  'anomaly.extension.images_grid_block_block': <ImagesGridBlock page={destination} block={block} />,
                  'anomaly.extension.tabs_block_block': <TabsBlock page={destination} block={block} />,
                  'anomaly.extension.slides_block_block': <SlidesBlock page={destination} block={block} />,
                  'anomaly.extension.highlights_block_block': <HighlightsBlock page={destination} block={block} />,
                  'anomaly.extension.embed_block_block': <EmbedBlock page={destination} block={block} />,
                  'anomaly.extension.content_block_block': <ContentBlock page={destination} block={block} />,
                  'anomaly.extension.book_block_block': <BookBlock page={destination} block={block} />,
                }[block.extension]
              }
            </Box>
          ))}

                          <MapContainer center={position as LatLngExpression} zoom={13} scrollWheelZoom={false} style={{ minHeight: L.Browser.mobile ? '50vh' : '60vh' }} tap={!L.Browser.mobile} dragging={!L.Browser.mobile}>
            <ChangeView center={position} zoom={13} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarkers />
          </MapContainer>

        </Box>
        </>
      )}

      {/* Lightbox Modal */}
      <Modal isOpen={lightboxOpen} onClose={closeLightbox} size="6xl" isCentered>
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent bg="transparent" boxShadow="none" maxW="90vw" maxH="90vh">
          <ModalCloseButton 
            color="white" 
            bg="blackAlpha.500" 
            borderRadius="full"
            _hover={{ bg: "blackAlpha.700" }}
            zIndex={10}
          />
          <ModalBody p={0} position="relative">
            <Box position="relative" w="100%" h="100%">
              {destination.d_gallery_images && destination.d_gallery_images[currentImageIndex] && (
                <Image
                  src={destination.d_gallery_images[currentImageIndex]}
                  alt={`Gallery image ${currentImageIndex + 1}`}
                  w="100%"
                  h="100%"
                  objectFit="contain"
                  maxH="90vh"
                />
              )}
              
              {/* Navigation Arrows */}
              {currentImageIndex > 0 && (
                <IconButton
                  aria-label="Previous image"
                  icon={<MdChevronLeft />}
                  onClick={previousImage}
                  position="absolute"
                  left={4}
                  top="50%"
                  transform="translateY(-50%)"
                  bg="blackAlpha.500"
                  color="white"
                  _hover={{ bg: "blackAlpha.700" }}
                  borderRadius="full"
                  size="lg"
                />
              )}
              
              {destination.d_gallery_images && currentImageIndex < destination.d_gallery_images.length - 1 && (
                <IconButton
                  aria-label="Next image"
                  icon={<MdChevronRight />}
                  onClick={nextImage}
                  position="absolute"
                  right={4}
                  top="50%"
                  transform="translateY(-50%)"
                  bg="blackAlpha.500"
                  color="white"
                  _hover={{ bg: "blackAlpha.700" }}
                  borderRadius="full"
                  size="lg"
                />
              )}
              
              {/* Image Counter */}
              <Box
                position="absolute"
                bottom={4}
                left="50%"
                transform="translateX(-50%)"
                bg="blackAlpha.500"
                color="white"
                px={3}
                py={1}
                borderRadius="full"
                fontSize="sm"
              >
                {currentImageIndex + 1} / {destination.d_gallery_images?.length || 0}
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

    </PageSlideFade >
  );
};

export default Destination;
